import React, { useState, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { MRsPageContext } from './content.js';
import Txt from '../../../inputs/textInput.js';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';
import {
  ContextualMenu,
  forceCloseContextualMenu,
  hideWhenClickAwayOrResize,
  showHideMenu,
} from '../../../shared/contextualMenu/content';
import {
  updateMeetingRoomSearch,
  getLastTimeMeetingRoomUsed,
  clickedJoinMeetingRoom,
  updateMeetingRoomForm,
  updateSelectedParticipantInMRForm,
  selectMeetingRoom,
  resetMRSearchForm,
  updateMRSearchForm,
  updateCurrentActivePageNo,
  createVidyoRoomAuthTicket,
  getMeetingRoomsByPage,
} from 'actions/meetingRoom.js';
import { displayGlobalMessage } from 'actions/globalMessage';
import { getCallQualityProfiles } from 'actions/portalSetting';
import { redirectToInternalLink } from 'businessLogic/redirector';
import { showEditMeetingRoomModal } from '../../../../actions/modal';
import {
  updateShowMeetingRoomParticipant,
  updateShowDeleteMeetingRoomModal,
  showResetGuestLinkModal,
} from '../../../../actions/modal';
import { Container, Loader } from 'semantic-ui-react';
import { Media, breakpoints } from '../../../../mediaSetting.js';
import { Waypoint } from 'react-waypoint';
import { useMediaQuery } from 'react-responsive';
import SearchContainer from './searchContainer';

const permissionsEnum = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  JOIN_ROOM: 'JOIN_ROOM',
  MODERATE_CALLS: 'MODERATE_CALLS',
  MANAGE_USERS: 'MANAGE_USERS',
};

export function insertAuthTicket(meetingRoomId, authTicket, array) {
  if (array.length > 1) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].meetingRoomId === meetingRoomId) {
        array[i] = {
          meetingRoomId: meetingRoomId,
          callScreenAuthTicket: authTicket,
        };
        break;
      }
      if (i === array.length - 1) {
        array.push({
          meetingRoomId: meetingRoomId,
          callScreenAuthTicket: authTicket,
        });
      }
    }
  } else {
    array.push({
      meetingRoomId: meetingRoomId,
      callScreenAuthTicket: authTicket,
    });
  }
  return array;
}

export function deleteAuthTicket(meetingRoomId, array) {
  let newAuthTicketArray = array.filter((x) => {
    return x.meetingRoomId != meetingRoomId;
  });
  return newAuthTicketArray;
}

export default function ViewAllCenterPanel(props) {
  const isMobileOrTablet = useMediaQuery({
    query: `(max-width: ${breakpoints.computer}px)`,
  });

  const dispatch = useDispatch();
  const [selectedParticipant, setSelectedParticipant] = useState({});
  const [isUserInThisCall, setIsUserInThisCall] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTermSubmitted, setSearchTermSubmitted] = useContext(MRsPageContext);
  const [fetchingAuthTicket, setFetchingAuthTicket] = useState(false);
  const [authTicketArray, setAuthTicketArray] = useState([]);

  useEffect(() => {
    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.meeting-room-view-all', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.meeting-room-view-all', event));

    return () => {
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.meeting-room-view-all', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.meeting-room-view-all', event));
    };
  }, []);

  const changeSearchTerm = (searchString, searchTermSubmitted) => {
    dispatch(updateMeetingRoomSearch(searchString));
    setSearchTermSubmitted(searchTermSubmitted);
  };

  const submitSearchTerm = (isFormSubmitted) => {
    let searchString = document.getElementById('searchBarInputMR').value || '';

    changeSearchTerm(searchString, isFormSubmitted);

    if (!isLoading) {
      // Reset users list form
      dispatch(resetMRSearchForm());
      // Store current search string
      let currentActivePageNo = 0;
      let fetchingPageNo = currentActivePageNo + 1;
      let mrSearchPayLoad = {
        searchString: searchString.trim(),
        pageNo: fetchingPageNo,
      };

      dispatch(updateMRSearchForm(mrSearchPayLoad));

      setIsLoading(true);
      let cb = (isThereAnyMeetingRoomsReturned) => {
        setIsLoading(false);

        if (isThereAnyMeetingRoomsReturned) {
          // Once data fetch finishes and fetched meetingrooms.length > 0, the active page no needs to be increased by 1
          dispatch(updateCurrentActivePageNo(1));
        }
      };
      dispatch(getMeetingRoomsByPage(mrSearchPayLoad, cb));
    }
  };

  const onSearchTermInputChange = (event) => {
    if (event.target != undefined) changeSearchTerm(event.target.value, false);
    else changeSearchTerm(event, false);
  };

  const clearSearchTerm = () => {
    changeSearchTerm('', false);
    setTimeout(() => {
      submitSearchTerm();
    }, 500);
  };

  const handleWaypointEnter = () => {
    let currentActivePageNo = props.mrSearchForm.currentActivePageNo;
    let fetchingPageNo = currentActivePageNo + 1;

    // Check if max rows limit has been reached
    if (props.mrSearchForm.totalRowsForSet == null || props.meetingRooms.length < props.mrSearchForm.totalRowsForSet) {
      if (!isLoading) {
        setIsLoading(true);

        let cb = (isThereAnyMeetingRoomsReturned) => {
          setIsLoading(false);

          if (isThereAnyMeetingRoomsReturned) {
            // Once data fetch finishes, the active page no needs to be increased by 1
            dispatch(updateCurrentActivePageNo(1));
          }
          if (props.mrSearchForm.searchString.trim() != '' && !searchTermSubmitted) {
            // When there's a search string and successful returned, searchTermSubmitted should be true to show the x
            setSearchTermSubmitted(true);
          }
        };
        let mrSearchPayLoad = {
          searchString: props.mrSearchForm.searchString.trim(),
          pageNo: fetchingPageNo,
        };
        dispatch(getMeetingRoomsByPage(mrSearchPayLoad, cb));
      }
    }
  };

  const getMeetingRoom = (roomId) => {
    let cb = () => {
      let meetingRoom = props.meetingRooms.find((x) => x.id == roomId);
      if (meetingRoom) {
        let postCallOption =
          meetingRoom.postCallOption && meetingRoom.postCallOption > 0 ? meetingRoom.postCallOption : 0;
        let editMeetingRoomPayload = {
          id: meetingRoom.id || '',
          name: meetingRoom.name || '',
          videoCallQualityId: meetingRoom.videoCallQualityId || 0,
          organisationNetworkId: meetingRoom.organisationNetworkId || 0,
          postCallUrl: meetingRoom.postCallUrl || '',
          callProviderUrl: meetingRoom.callProviderUrl || '',
          callerGuestUrl: meetingRoom.callerGuestUrl || '',
          postCallOption: postCallOption,
        };
        dispatch(selectMeetingRoom(meetingRoom));
        dispatch(updateMeetingRoomForm(editMeetingRoomPayload));
      }
      dispatch(showEditMeetingRoomModal(true));
    };

    dispatch(getCallQualityProfiles(cb));
  };

  const manageUsers = (room) => {
    redirectToInternalLink('meeting-room/manage-users/' + room.id);
  };

  const deleteMeetingRoom = (roomId) => {
    let cb = () => {
      //call show delete func
      dispatch(updateShowDeleteMeetingRoomModal(true));
    };

    dispatch(updateMeetingRoomForm(props.meetingRooms.find((x) => x.id == roomId)));
    dispatch(getLastTimeMeetingRoomUsed(roomId, cb));
  };

  const joinMeetingRoom = (roomId) => {
    let meetingRoomUserWantsToJoin = authTicketArray.find((x) => x.meetingRoomId == roomId);
    dispatch(clickedJoinMeetingRoom(roomId));
    window.open(
      window.APP.CONFIGURATION.CALLSCREEN_LOCATION + '#/?authticket=' + meetingRoomUserWantsToJoin.callScreenAuthTicket,
      null,
      'width=' + (screen.width - 20) + ',height=' + (screen.height - 100) + ', left=0, top=0, scrollbars=yes,status=yes'
    );
    // Delete the auth ticket
    let array = [...authTicketArray];
    let newArray = deleteAuthTicket(roomId, array);
    setAuthTicketArray(newArray);
    //forceClose the contextual-menu
    setTimeout(() => {
      forceCloseContextualMenu('.row.flexible.row-hoverable.active');
    }, 200);
  };

  const copyInvitationLinkToClipboard = (roomId) => {
    let callback = (meetingRoom) => {
      var clipboard = new window.Clipboard('.copy-to-clipboard-button-meeting-room', {
        text: () => {
          return meetingRoom.roomUrl;
        },
      });
    };
    //CHECKING if data is already loaded or not
    let meetingRoom = props.meetingRooms.find((x) => x.id == roomId);
    if (meetingRoom) {
      dispatch(updateMeetingRoomForm(meetingRoom));
      callback(meetingRoom);
    }
  };

  const resetGuestLink = (roomId) => {
    dispatch(showResetGuestLinkModal(true));
  };

  const openParticipantModal = (isUserInThisCall, particpant) => {
    setSelectedParticipant(particpant);
    setIsUserInThisCall(isUserInThisCall);
    dispatch(
      updateSelectedParticipantInMRForm({
        selectedParticipant: particpant,
        isUserInThisCall,
      })
    );
    dispatch(updateShowMeetingRoomParticipant(true));
  };

  const showCopyLinkToClipboardGlobalMessage = (meetingRoomName) => {
    var successMessage = APP.LANGUAGE.CopyLinkToClipboard.SuccessfulMessage.replace('##meetingRoom##', meetingRoomName);
    dispatch(
      displayGlobalMessage({
        text: successMessage,
        visible: true,
        messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
        autoHide: true,
      })
    );
    //forceClose the contextual-menu
    setTimeout(() => {
      forceCloseContextualMenu('.row.flexible.row-hoverable.active');
    }, 200);
  };

  const renderMeetingRoomsRows = (meetingRoomsList, gray) => {
    let iterator = meetingRoomsList;
    let participants = '';
    return iterator.map((room, i) => {
      let dynamicId = room.id;

      room.participants = room.participants == undefined ? [] : room.participants;

      let participantsIcon = <div className="mrlm pdlxs" />;
      let addBoldClass = ''; //we will only add if there are participants
      if (room.participants.length > 0) {
        let participantList = room.participants.map((participant, i) => {
          const guest = participant.isGuestCaller ? ' (' + APP.LANGUAGE.MeetingRoomPersonStatus.Guest + ')...' : '...';
          return {
            text: participant.name + guest,
            onClick: () => {
              /*open o into a modal*/
              openParticipantModal(
                props.currentMeetingRoomCall && props.currentMeetingRoomCall.id === room.id,
                participant
              );
            },
            id: i + room.id,
          };
        });
        participants = (
          <Txt
            key={room.id}
            multiple={true}
            semanticui
            dropdown
            text={APP.LANGUAGE.ViewMeetingRoom.ParticipantsAction}
            noIcon={true}
            className=" button labeled color-info max-width no-bold icon left-text normal participantsdropdown"
            options={participantList}
          />
        );

        participantsIcon = (
          <i className=" icon color-meeting-room users text-size-mml mrrxs" style={{ minWidth: '23px' }} />
        );
        addBoldClass = ' bold ';
      } else {
        participantsIcon = (
          <i className=" icon color-neutral-center-gray users  text-size-mml mrrxs" style={{ minWidth: '23px' }} />
        );
        participants = (
          <div className="ui  max-width disable-msg">
            <span className="text">{APP.LANGUAGE.ViewMeetingRoom.NoParticipantsMessage}</span>
          </div>
        );
      }

      let contextualMenu = '';
      let joinTitle = fetchingAuthTicket ? (
        <div className="color-placeholder">
          {APP.LANGUAGE.ViewMeetingRoom.JoinAction}
          <i className="ui icon spinner loading icon waiting-area-green fr" />
        </div>
      ) : (
        <div>
          {APP.LANGUAGE.ViewMeetingRoom.JoinAction}
          <i className="mrls ui icon sign in waiting-area-green fr" />
        </div>
      );
      contextualMenu = (
        <ContextualMenu
          id={dynamicId}
          renderChildLast={true}
          options={[
            {
              title: joinTitle,
              customAction: true,
              isFetching: false,
              show: room.permissions.indexOf(permissionsEnum.JOIN_ROOM) > -1 && !props.isInCall,
              action: () => joinMeetingRoom(room.id),
              fieldClass: fetchingAuthTicket ? 'disable-msg' : '',
            },
            {
              //if in current room display "InCurrentRoom" otherwise "AlreadyInCall" MESSAGE
              title:
                props.currentMeetingRoomCall && props.currentMeetingRoomCall.id === room.id
                  ? APP.LANGUAGE.ViewMeetingRoom.InCurrentRoom
                  : APP.LANGUAGE.ViewMeetingRoom.AlreadyInCall,
              customAction: false,
              isFetching: false,
              show: props.isInCall == true,
              fieldClass: 'disable-msg',
            },
            {
              title: APP.LANGUAGE.InviteGuest.CopyLinkToClipboard,
              fieldClass: 'copy-to-clipboard-button-meeting-room',
              customAction: true,
              openInModal: true,
              isFetching: false,
              show: room.permissions.indexOf(permissionsEnum.VIEW) > -1,
              action: () => {
                console.log('Meeting room invite link:' + room.roomUrl);
                showCopyLinkToClipboardGlobalMessage(room.name);
              },
            },
            {
              title: APP.LANGUAGE.ViewMeetingRoom.ResetGuestLink,
              customAction: true,
              openInModal: true,
              isFetching: false,
              show: room.permissions.indexOf(permissionsEnum.EDIT) > -1,
              action: () => resetGuestLink(room.id),
            },
            {
              title: APP.LANGUAGE.ViewMeetingRoom.EditAction,
              customAction: true,
              openInModal: true,
              isFetching: false,
              show: room.permissions.indexOf(permissionsEnum.EDIT) > -1,
              action: () => getMeetingRoom(room.id),
            },
            {
              title: APP.LANGUAGE.ViewMeetingRoom.ManageUserAction,
              customAction: true,
              show: room.permissions.indexOf(permissionsEnum.MANAGE_USERS) > -1,
              action: () => manageUsers(room),
            },
            {
              title: APP.LANGUAGE.ViewMeetingRoom.DeleteAction,
              customAction: true,
              isFetching: false,
              show: room.permissions.indexOf(permissionsEnum.DELETE) > -1,
              active: room.participants && room.participants.length == 0,
              action: () => deleteMeetingRoom(room.id),
            },
          ]}
        >
          {participants}
        </ContextualMenu>
      );

      const meetingRoomColumnMarkup = (
        <React.Fragment>
          <Container fluid as={Media} greaterThanOrEqual="tablet" className="inline-flex center-flex">
            {participantsIcon}
            <div className="wrap-link">
              {room.name}
              <span>{` (` + room.organisationName + `)`}</span>
            </div>
          </Container>
          <Container fluid as={Media} at="mobile" className="inline-flex center-flex">
            {participantsIcon}
            <div className="wrap-link">{room.name}</div>
          </Container>
        </React.Fragment>
      );
      return (
        <div
          className={props.isOnMobileOrTablet ? 'row flexible row-hoverable mrlm mrrm' : 'row flexible row-hoverable'}
          data-opaque={!!gray}
          key={room.id}
          onClick={(event) => {
            dispatch(selectMeetingRoom(room));
            showHideMenu(
              null,
              '.main-ui-container.meeting-room-view-all.new-waiting-area-view-one',
              dynamicId,
              event.target,
              event.currentTarget,
              200
            );
            copyInvitationLinkToClipboard(room.id);
            // TODO - Need to remove the autickets when user leaves this page
            if (
              room.permissions.indexOf(permissionsEnum.JOIN_ROOM) > -1 &&
              (!authTicketArray || (authTicketArray && !authTicketArray.some((x) => x.meetingRoomId === room.id)))
            ) {
              setFetchingAuthTicket(true);
              var cbGetAuthTicket = (result, callScreenAuthTicket) => {
                if (!result) {
                  console.error('No Auth Ticket was created');
                  return;
                }
                let array = [...authTicketArray];
                let newArray = insertAuthTicket(room.id, callScreenAuthTicket, array);
                setAuthTicketArray(newArray);
                setFetchingAuthTicket(false);
              };
              dispatch(createVidyoRoomAuthTicket(room.id, cbGetAuthTicket));
            }
          }}
        >
          {contextualMenu}
          {/*mobile and desktop shares different layout, so it needs to wrap the elements within a div for mobile individually */}
          <div className="mobile only column left-text column max-width pdlxs pdrxs">
            {meetingRoomColumnMarkup}
            <div
              className={'ui text-size-ms mobileSecondRow left-text pdlxxs iconClear' + addBoldClass}
              style={{ wordBreak: 'break-all' }}
            >
              {'(' + room.organisationName + ')'}
            </div>
          </div>
          <div
            className={
              (props.isOnMobileOrTablet ? 'pdlxs pdrxs ' : '') +
              'tablet only computer only column left-column-fixed status-column left-text users-column inline-flex center-flex max-width' +
              addBoldClass
            }
          >
            {meetingRoomColumnMarkup}
          </div>
        </div>
      );
    });
  };

  const generateMRRowMarkup = () => {
    if (props.meetingRooms && props.meetingRooms.length > 0) {
      const sortedMeetingRoomsList = props.meetingRooms;
      let meetingRoomMatchingSearchTerm = sortedMeetingRoomsList;

      return renderMeetingRoomsRows(meetingRoomMatchingSearchTerm, false);
    } else if (!isLoading) {
      return (
        <div className="row flexible row-hoverable">
          <div className="center-text pdts pdbs">{APP.LANGUAGE.ViewMeetingRoom.NoSearchResults}</div>
        </div>
      );
    } else {
      return '';
    }
  };

  const tableHeaderMarkup = (
    <div className="row flexible color-secondary pdtnull pdbnull header-row">
      {/* Column #1 header */}
      <span className="ui nine wide tablet only nine wide computer only eight wide mobile column color-white display-flex">
        <div className={'color-white max-width pdxs left-text ' + props.isOnMobileOrTablet ? '' : 'pdlnull'}>
          {APP.LANGUAGE.ViewMeetingRoom.GroupPlaceholder}
        </div>
      </span>
      {/* Column #2 header */}
      <span className="ui seven wide tablet  seven wide computer  eight wide mobile  column  icon input color-white hand display-flex">
        <SearchContainer
          onChange={onSearchTermInputChange}
          id="searchBarInputMR"
          className="ui color-white input color-meeting-room-bg-highlight max-width pdxs"
          maxlength="500"
          onKeyUpHandler={() => {
            submitSearchTerm(true);
          }}
          placeholder={APP.LANGUAGE.ViewMeetingRoom.MeetingRoomPlaceholder}
          autoComplete="not-enable"
          disabled={isLoading}
        />
        {!searchTermSubmitted ? (
          <i className="search icon mrrml hand" onClick={submitSearchTerm} style={{ pointerEvents: 'auto' }} />
        ) : (
          <i
            className="delete icon mrrml hand"
            onClick={clearSearchTerm}
            style={{ pointerEvents: 'auto', opacity: !isLoading ? 1 : '' }}
          />
        )}
      </span>
    </div>
  );

  return (
    <div>
      <Container fluid as={Media} lessThan="computer" className="ui center aligned padded grid">
        {tableHeaderMarkup}
        {generateMRRowMarkup()}
        {isMobileOrTablet && (
          <Waypoint onEnter={handleWaypointEnter}>
            <div className="waypoint mrts mrbs" />
          </Waypoint>
        )}
        {isLoading ? (
          <div className="mrtm mrbm">
            <Loader active inline="centered" />
          </div>
        ) : (
          ''
        )}
      </Container>
      <Container fluid className="ui equal width center aligned padded grid" as={Media} greaterThanOrEqual="computer">
        {tableHeaderMarkup}
        <div className="desktop-scrolling-wrapper max-width pdlnull pdrnull">
          <div className="ui center aligned padded grid pdlnull pdrnull" id="desktop-scrolling-wrapper-users">
            {
              <div className="row flexible row-hoverable" /> /* Have to add this empty div with .row class, to show the bottom border for other rows */
            }
            {generateMRRowMarkup()}
            {isLoading ? (
              <div className="mrtm mrbxl">
                <Loader active inline="centered" />
              </div>
            ) : (
              <div className="flexible row-hoverable" style={{ height: '150px' }} />
            )}
            {!isMobileOrTablet && (
              <Waypoint onEnter={handleWaypointEnter}>
                <div className="waypoint" />
              </Waypoint>
            )}
          </div>
          <ScrollToTopButton className="scroll-top-btn-mobile" targetElement=".desktop-scrolling-wrapper-users" />
        </div>
      </Container>
    </div>
  );
}
